import { useReveal } from "@/hooks/useReveal";

// Opacity-only reveal (no rise/translate) -- used where a slide-in would
// feel wrong, e.g. the hero founder portrait which should only fade in.
const FadeIn = ({ children, className = "", delay = 0 }) => {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      className={`hero-fade-in ${visible ? "hero-fade-in-visible" : ""} ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : "0ms" }}
    >
      {children}
    </div>
  );
};

export default FadeIn;
